<sb-dashboard-widget
  [isLoading]="isLoading()"
  [isEmpty]="exchanges().length === 0"
  [title]="'My exchanges' | translate"
  [emptySettings]="{
    description: 'No exchanges yet - any shift swaps will appear here.' | translate,
    icon: 'calendar-time-add-cute-re',
  }"
>
  <!-- TODO check e2e, this probably isn't targeting the input itself now -->
  <sb-dashboard-widget-select
    [options]="periodOptions"
    [model]="widgetPeriod()"
    (modelChange)="onPeriodChange($event)"
    [label]="'Next' | translate"
  />
  <table class="table-widget table-uniform-rows">
    <thead>
      <tr>
        <th class="row-30">{{ 'Date' | translate }}</th>
        <th class="row-30">{{ 'Time' | translate }}</th>
        <th class="row-20">{{ 'Team' | translate }}</th>
        <th class="row-20">{{ 'Shift' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (exchange of exchanges(); track exchange.id) {
        <tr
          class="cursor-pointer"
          role="link"
          [routerLink]="['', { outlets: { modal: ['exchange-request', exchange.id] } }]"
        >
          <td>{{ exchange.date | localeDate: 'medium' }}</td>
          <td>
            <span>{{ exchange.Schedule?.starttime | time }}</span>
            @if (!exchange.Schedule?.hide_end_time) {
              <span> - {{ exchange.Schedule?.endtime | time }}</span>
            }
          </td>
          <td>{{ exchange.Schedule?.Team?.name }}</td>
          <td>{{ exchange.Schedule?.Shift?.long_name }}</td>
        </tr>
      }
    </tbody>
  </table>
</sb-dashboard-widget>
